export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";